<template>
  <div class="bg-base-0 upgrade-page">
    <div class="padding">
      <canvas id="firework-canvas" v-show="doneUpgrade" />
      <div v-show="!alreadyUpgrade">
        <div v-show="!doneUpgrade">
          <div v-show="paymentType">
            <h2 class="text-center title-upgrade">
              AhaSlides {{ plan.name }}
            </h2>

            <div class="flex flex-wrap justify-center">
              <div class="upgrade-section form-section">
                <span
                  class="block mb-4 text-base text-black-100 font-bold"
                  v-if="isShowIdealPayment"
                >Payment method</span>
                <div
                  class="card-form"
                  :class="{'shadow' : paymentOption === PAYMENT_METHOD.CARD}"
                  v-if="isShowCardPayment"
                >
                  <div
                    class="existing-card"
                    :class="{'card-collapsed' : isCardSectionCollapsed}"
                    v-if="currentCard.id"
                  >
                    <h4 class="mb-2 text-lg">
                      {{ $i18nPresenter.t("Existing Credit / Debit Card") }}
                    </h4>
                    <div
                      class="show-existing-card"
                      :class="{'active': userOldCard}"
                      @click="userOldCard = !userOldCard"
                    >
                      <i class="far fa-check-square fa-fw" v-if="userOldCard" />
                      <i class="far fa-square fa-fw" v-if="!userOldCard" />
                      <span
                        v-html="$i18nPresenter.t('cardEndingIn', {
                          brand: currentCard.brand,
                          last4: currentCard.last4
                        })"
                      ></span>
                    </div>
                  </div>
                  <div class="flex mb-2">
                    <aha-radio
                      name="paymentOption"
                      v-model="paymentOption"
                      value="card"
                      v-if="isShowIdealPayment"
                      @change="onChangePaymentOption"
                    >
                      <h4 class="text-lg">
                        Credit / Debit Card
                      </h4>
                    </aha-radio>
                    <h4 v-else class="text-lg">
                      {{ $i18nPresenter.t("Pay with Credit / Debit Card") }}
                    </h4>
                    <img
                      v-if="isShowIdealPayment"
                      src="@/assets/images/image.png"
                      alt
                      class="card-img-logo ml-auto hidden lg:block"
                      width="140"
                    >
                  </div>
                  <div :class="{'card-collapsed' : isCardSectionCollapsed}">
                    <label class="card-form--label">
                      {{ $i18nPresenter.t("Card number:") }}
                    </label>
                    <div id="card-number" />
                    <p class="mb-3 text-red-50" v-if="textErrorCard">
                      {{ textErrorCard }}
                    </p>
                    <label class="card-form--label">
                      {{ $i18nPresenter.t("Expiration date:") }}
                    </label>
                    <div id="card-expiry" />
                    <p class="mb-3 text-red-50" v-if="textErrorExpired">
                      {{ textErrorExpired }}
                    </p>

                    <label class="card-form--label">
                      CVV / CVC:
                    </label>
                    <div id="card-cvc" />
                    <p class="mb-3 text-red-50" v-if="textErrorCvc">
                      {{ textErrorCvc }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="isShowIdealPayment"
                  class="card-form flex items-center flex-wrap"
                  :class="{'shadow' : paymentOption === PAYMENT_METHOD.IDEAL}"
                >
                  <div class="inline-flex w-full">
                    <aha-radio
                      name="paymentOption"
                      value="ideal"
                      v-model="paymentOption"
                      @change="onChangePaymentOption"
                    >
                      <h4>
                        <span class="text-lg">
                          iDEAL payments
                        </span>
                      </h4>
                    </aha-radio>
                    <img
                      src="@/assets/images/payments/iDEAL.png"
                      class="ml-auto block"
                      style="max-height: 32px;"
                    >
                  </div>
                  <div class="inline-flex w-full h-6 mt-3" v-if="idealLoading">
                    <div class="loading-wrapper">
                      <div class="">
                        <div class="loading ideal" />
                        <div class="loading ideal" />
                      </div>
                    </div>
                  </div>
                  <div class="mt-2" v-if="!idealLoading && dataIdeal.bank">
                    <div class="mb-2">
                      <span>Bank</span>
                      <span class="ml-2 font-thin"> {{ dataIdeal.bank }}</span>
                    </div>
                    <div>
                      <span>Card</span>
                      <span class="ml-2 font-thin"> **** **** **** {{ dataIdeal.last4 }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="upgrade-section">
                <div class="ui-layout" v-if="loading">
                  <section class="ui-card">
                    <div class="loading-wrapper">
                      <div class="title-block">
                        <div class="loading title" />
                        <div class="loading content" />
                        <div class="loading content last-row" />
                      </div>
                      <div class="title-block">
                        <div class="loading title" />
                        <div class="loading content" />
                        <div class="loading content last-row" />
                      </div>
                    </div>
                  </section>
                </div>

                <div v-if="!loading">
                  <div v-if="!alreadyUpgrade" class="content-plan">
                    <h5 class="mb-2">
                      {{ plan.name }}
                    </h5>
                    <div class="line-invoice horizontal layout">
                      <div class="line-label">
                        {{ $i18nPresenter.t("Account") }}
                      </div>
                      <div class="flex line-value text-base-90">
                        <span>{{ $store.state.currentUser.email }}</span>
                      </div>
                    </div>
                    <div
                      class="line-invoice horizontal layout"
                      v-if="$store.state.plan.type != 'free'"
                    >
                      <div class="line-label">
                        {{ $i18nPresenter.t('Old plan') }}
                      </div>
                      <div class="flex line-value text-base-90">
                        <span>{{ $store.state.plan.name }}</span>
                      </div>
                    </div>
                    <div class="line-invoice horizontal layout">
                      <div class="line-label">
                        {{ $i18nPresenter.t('New plan') }}
                      </div>
                      <div class="flex line-value text-base-90">
                        {{ plan.name }}
                      </div>
                    </div>
                    <div class="line-invoice horizontal layout" v-if="plan.billingCycle">
                      <div class="line-label">
                        {{ $i18nPresenter.t('New billing cycle') }}
                      </div>
                      <div class="flex capitalize line-value text-base-90">
                        <span>{{ plan.billingCycle }}</span>
                      </div>
                    </div>
                    <div class="line-invoice horizontal layout" v-if="!isSubscription">
                      <div class="line-label">
                        {{ $i18nPresenter.t('Price') }}
                      </div>
                      <div class="flex line-value text-base-90">
                        <span>{{ plan.price | floatNumber }} {{ getCurrency }}</span>
                      </div>
                    </div>
                    <div v-if="isSubscription">
                      <div class="line-invoice horizontal layout" v-if="!plan.perMonth">
                        <div class="line-label">
                          {{ $i18nPresenter.t('Monthly price') }}
                        </div>
                        <div class="flex line-value text-base-90">
                          <span>{{ plan.price | floatNumber }} {{ getCurrency }}</span>
                        </div>
                      </div>
                      <div class="line-invoice horizontal layout" v-if="plan.perMonth">
                        <div class="line-label">
                          {{ $i18nPresenter.t('Monthly price') }}
                        </div>
                        <div class="flex line-value text-base-90">
                          <span>{{ plan.perMonth }} {{ getCurrency }}</span>
                        </div>
                      </div>
                      <div class="line-invoice horizontal layout" v-if="plan.perMonth">
                        <div class="line-label">
                          {{ $i18nPresenter.t('Yearly price') }}
                        </div>
                        <div class="flex line-value text-base-90">
                          <span>{{ plan.price | floatNumber }} {{ getCurrency }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="line-invoice horizontal layout bold proration"
                      v-if="isSubscription && upcomingInvoice.proration"
                    >
                      <div class="line-label">
                        {{ $i18nPresenter.t('Credit') }}
                      </div>
                      <div class="flex line-value">
                        <span>{{ upcomingInvoice.proration }} {{ getCurrency }}</span>
                      </div>
                    </div>
                    <div
                      class="line-invoice horizontal layout bold proration"
                      v-if="upcomingInvoice.credit"
                    >
                      <div class="line-label">
                        {{ $i18nPresenter.t('Credit') }}
                      </div>
                      <div class="flex line-value text-base-90">
                        <span>{{ upcomingInvoice.credit }} {{ getCurrency }}</span>
                      </div>
                    </div>

                    <div
                      v-if="promo || cancellationOffer"
                      class="py-4 my-4 border-t border-b border-base-50"
                    >
                      <div class="line-invoice horizontal layout">
                        <div class="line-label bold">
                          {{ $i18nPresenter.t('Total') }}
                        </div>
                        <div class="flex font-bold line-value text-base-90">
                          <span>{{ upcomingInvoice.subtotal }} {{ getCurrency }}</span>
                        </div>
                      </div>
                      <div class="line-invoice horizontal layout">
                        <div class="font-bold line-label">
                          <i class="fas fa-gift" /> {{ $i18nPresenter.t('Promo code') }}
                        </div>
                        <div class="flex font-bold line-value value-coupon text-green-50">
                          <span>{{ upcomingInvoice.couponAmount }} {{ getCurrency }}</span>
                        </div>
                      </div>
                      <p class="flex items-center text-base-80">
                        <span v-if="cancellationOffer" class="mr-1">{{ coupon.name }}</span>
                        <span v-else class="mr-1">{{ coupon.id }}: {{ coupon.name }}</span>
                        <a
                          href="#"
                          @click.prevent="removeCoupon()"
                          v-if="isAddCoupon && !isRemoving && !isCancellationOffer(coupon)"
                        >
                          <font-awesome-icon
                            :icon="['far', 'times-circle']"
                            fixed-width
                          />
                        </a>
                        <aha-spinner
                          v-if="isRemoving"
                          class="ml-1"
                          size="xs"
                        />
                      </p>
                    </div>
                    <div class="line-invoice horizontal layout">
                      <div class="line-label">
                        {{ $i18nPresenter.t('VAT 0%') }}
                      </div>
                      <div class="flex line-value text-base-90">
                        0.00 {{ getCurrency }}
                      </div>
                    </div>
                    <div class="line-invoice horizontal layout center total bold">
                      <div class="line-label">
                        {{ $i18nPresenter.t('Total billed now') }}
                      </div>
                      <div class="flex line-value total-value">
                        {{ upcomingInvoice.total }} {{ getCurrency }}
                      </div>
                    </div>

                    <div
                      class="mb-5 add-promotion"
                      v-if="true && (paymentOption !== 'ideal')"
                    >
                      <div
                        class="text-xs label-promotion text-link--muted"
                        v-if="false"
                        @click="showInputPromo()"
                      >
                        {{ $i18nPresenter.t('Add reference code') }}
                      </div>
                      <div class="form-add-promotion">
                        <div
                          class="mb-3 add-coupon-wrapper"
                        >
                          <aha-input
                            type="text"
                            v-model="inputCoupon"
                            class="absolute top-0 left-0 mb-3 add-coupon-input"
                            :placeholder="placeholder_EnterCodeOptional"
                            classes="uppercase"
                            @keyup.enter="checkPromotion()"
                          />
                          <p class="mb-3 text-red-50" v-if="promotionError">
                            {{ promotionError }}
                          </p>
                          <aha-button
                            class="absolute top-1.5 right-1"
                            variant="base"
                            @click="checkPromotion()"
                            :disabled="!inputCoupon"
                            size="sm"
                          >
                            <span class="add-btn">{{ $i18nPresenter.t('Add') }}</span>
                            <aha-icon
                              name="add"
                              width="16"
                              height="13"
                              viewBox="0 0 24 24"
                              class="ml-1"
                              v-if="!isCheckingPromo"
                            />
                            <aha-spinner v-if="isCheckingPromo" class="ml-1" size="xs" />
                          </aha-button>
                        </div>
                      </div>
                    </div>

                    <div class="my-2 text-center">
                      <aha-button
                        v-if="paymentOption === PAYMENT_METHOD.CARD"
                        class="upgrade-btn"
                        @click="checkout()"
                        :disabled="checkDisableCheckout()"
                      >
                        <span
                          class="text-base btn-upgrade--text"
                          :class="{
                            'btn-upgrade--text-ok': textUpgrade === 'OK',
                            'btn-upgrade--text-buy': textUpgrade === 'Buy now',
                            'btn-upgrade--text-upgrade': textUpgrade === 'Upgrade',
                          }"
                        >{{ translateTextUpgrade }}</span>
                        <span v-if="!isCheckout"><aha-icon name="check" /></span>
                        <aha-spinner
                          variant="white"
                          v-else
                        />
                      </aha-button>
                      <aha-button
                        class="upgrade-btn"
                        v-if="paymentOption === PAYMENT_METHOD.IDEAL"
                        @click="idealCheckout()"
                        :disabled="idealCheckDisableCheckout()"
                      >
                        <span
                          class="text-base btn-upgrade--text btn-upgrade--text-upgrade"
                        >Upgrade</span>
                        <span v-if="!isCheckout"><aha-icon name="check" /></span>
                        <aha-spinner
                          variant="white"
                          v-else
                        />
                      </aha-button>
                      <p class="my-3 verifying" v-if="isCheckout">
                        {{ $i18nPresenter.t('Verifying payment, please wait..') }}
                      </p>
                    </div>
                    <div class="flex justify-center">
                      <p class="mt-2 text-sm secure-notice">
                        <i class="pr-1 fas fa-lock fa-fw" />
                        <span
                          v-html="$i18nPresenter.t('yourPaymentIsHandledSecurely', {
                            brand: isCapturingPaypalPayment ? 'PayPal' : 'Stripe'
                          })"
                        ></span>
                      </p>
                    </div>

                    <p class="info-box-error" v-if="textError">
                      <aha-info-box variant="error">
                        <div class="pl-1">
                          <div v-html="textError" />
                          <div
                            class="mt-1 text-base-80"
                            v-if="isShowingFurtherSupportText"
                            @click="openChat()"
                          >
                            {{ $i18nPresenter.t('Need support?') }} <aha-link class="underline" size="xs">
                              {{ $i18nPresenter.t('Chat with us') }}
                            </aha-link>.
                          </div>
                        </div>
                      </aha-info-box>
                    </p>

                    <div class="paypal__wrapper-text" v-if="isShowPaypal">
                      <img src="@/assets/images/logos/paypal-logo.svg">
                      <p
                        @click="handleClickPayWithPaypal"
                        class="pl-2"
                      >
                        <span v-html="$i18nPresenter.t('youCanAlsoPayWithPaypal')"></span>
                      </p>
                    </div>

                    <div
                      v-if="isShowPaypalFromCS && isPayPalButtonVisible
                        && !isCapturingPaypalPayment"
                      ref="paypal"
                      class="paypal-btn"
                      :class="{'disabled': isCheckout}"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="!paymentType" class="px-4">
            <div class="upgrade-success-content">
              <h2 class="text-center title-upgrade">
                <span
                  v-html="$i18nPresenter.t('cantUpgradeToAhaPlanName', {
                    plan: plan.name
                  })"
                ></span>
              </h2>

              <p class="text-left cannot-upgrade-des">
                Your account
                <strong>({{ $store.state.currentUser.email }})</strong>
                is on AhaSlides {{ $store.state.plan.name }} plan.
                You cannot upgrade to AhaSlides {{ plan.name }}.
                For more information on your current plan,
                please <aha-link class="underline" @click="redirectToMyPlan()">
                  go here
                </aha-link>.
              </p>
              <p class="text-left cannot-upgrade-des">
                <span v-html="$i18nPresenter.t('pleaseEmailUsAt')">
                </span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="doneUpgrade" class="upgrade-success-content">
          <div class="mt-10">
            <h2 class="px-4 mb-3 text-center">
              AhaSlides {{ $store.state.plan.name }}
            </h2>
            <h2 class="px-4 mb-3 text-center">
              {{ $i18nPresenter.t('Thank you for upgrading!') }}
            </h2>
            <div class="text-center congrats-upgrade">
              <i class="fas fa-check-circle fa-3x text-green-50" />
              <p
                class="my-3 congrats-text"
              >
                {{ $i18nPresenter.t('We hope that you will have many successful events with AhaSlides!') }}
              </p>
            </div>
          </div>
          <div class="flex justify-center">
            <aha-button @click="goToMyPresentations">
              <span class="mr-1">{{ backToPresentation.length > 0 ? $i18nPresenter.t( 'Go to my presentation') : $i18nPresenter.t('Go to my presentations') }}</span>
              <span><font-awesome-icon icon="angle-right" /></span>
            </aha-button>
          </div>
        </div>
      </div>

      <div v-if="alreadyUpgrade" class="upgrade-success-content">
        <h2 class="text-center title-upgrade">
          AhaSlides {{ plan.name }}
        </h2>

        <div class="text-center congrats-upgrade">
          <i class="fas fa-check-circle fa-3x text-green-50" />
          <p class="my-3 congrats-text">
            <span
              v-html="$i18nPresenter.t('alreadyOnAhaslidesPlan', {
                plan: $store.state.plan.name
              })"
            ></span>
          </p>
        </div>
        <div class="flex justify-center">
          <aha-button>
            <router-link class="text-base-0 hover:text-base-0" to="/apps/presentations">
              <span class="mr-1">{{ $i18nPresenter.t('Go to my presentations') }}</span>
              <span><font-awesome-icon icon="angle-right" /></span>
            </router-link>
          </aha-button>
        </div>
      </div>
    </div>
    <div class="mb-8 font-bold text-left  " v-if="!doneUpgrade && backToPresentation.length > 0 && trace.length === 0">
      <span
        class="text-base-90 space-button cursor-pointer"

        @click="viewAllPlan()"
      >
        {{ $i18nPresenter.t('View all plans') }}
        <aha-icon name="arrow-tail" class="icon-tail" />
      </span>
    </div>
    <div
      class="more-information bg-base-0"
    >
      <div class="item-information">
        <div
          :class="{'power-by-hidden' : isShowIdealPayment}"
          class="mt-5 power-by"
        >
          <div class="card-img-logo__wrapper">
            <img src="@/assets/images/image.png" alt class="card-img-logo">
          </div>
          <div class="paypal-stripe__wrapper">
            <img src="@/assets/images/logos/Stripe-logo.svg" alt>
            <span class="power-by-paypal" v-if="isShowPaypalFromCS">
              <img src="@/assets/images/logos/PayPal-logo2.svg" alt>
            </span>
          </div>
        </div>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('We use secure connections') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('weUseHTTPSsecure')"></span>
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('We do not store credit card information') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('weNeverStoreCreditCardInfomation')">
          </span>
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('14-day money back guarantees') }}
        </h4>
        <p class="text-sm">
          {{ $i18nPresenter.t(`If you wish to cancel within fourteen (14) days from the day you subscribed, and you have not successfully used AhaSlides at a live event, you will receive a full refund.`) }}
        </p>
      </div>
      <div class="item-information">
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('Terms of use') }}
        </h4>
        <p class="text-sm">
          <span v-html="$i18nPresenter.t('readAhaslidesFullTermsOfUse')"></span>
        </p>
      </div>
      <div
        class="item-information"
        v-if="isShowPaypalFromCS && !isLatestInVoiceByStripe && !doneUpgrade && !loading"
      >
        <h4 class="mb-1 text-lg font-bold">
          {{ $i18nPresenter.t('Alternative payment methods') }}
        </h4>
        <p class="text-sm">
          If you wish to pay via PayPal, please <aha-link
            class="underline"
            @click="handleClickPayViaPayPal()"
          >
            click here
          </aha-link>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import confetti from 'canvas-confetti'
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Util from '@/util'
import Config from '@/config'
import Constant from '@/constant'
import Pricing from '@/pricing'
import PricingApi from '@/api/pricing'
import InvoiceApi from '@/api/invoice'
import ABTestApi from '@/api/abTest'
import eventCategories from '@/constant/eventCategories'
import zoho from '@/services/zoho'
import mixpanelUtils from '@/utils/mixpanel.utils'

const CURRENCY = {
  USD: 'USD',
  EUR: 'EUR',
}
const PAYMENT_METHOD = {
  IDEAL: 'ideal',
  CARD: 'card',
}
const IDEAL_AB_TEST_GROUP = {
  CONTROL: 'CONTROL',
  TREATMENT: 'TREATMENT',
}

const USER_PLAN = {
  FREE: 'free',
}

const USER_CURRENCY = {
  USD: 'usd',
  EUR: 'eur',
}

const USER_COUNTRY = {
  NETHERLANDS: 'Netherlands',
}

const AB_TEST_CODE = {
  IDEAL: 'IDEAL',
}

const PAYMENT_SOURCE = {
  IDEAL: 'iDEAL',
}
export default {
  name: 'Upgrade',
  data() {
    return {
      plan: {},
      currency: null,
      domain: '',
      url: '',
      stripe: null,
      loading: true,
      doneUpgrade: false,
      alreadyUpgrade: false,
      isSubscription: false,
      isCheckout: false,
      textUpgrade: 'Upgrade',
      card: null,
      cardExpiry: null,
      cardCvc: null,
      currentCard: {},
      userOldCard: true,
      textError: '',
      textErrorCard: '',
      textErrorExpired: '',
      textErrorCvc: '',
      isValidCard: false,
      isValidExpired: false,
      isValidCvc: false,
      hasPaidInvoice: false,
      promo: '',
      isAddCoupon: false,
      promotionError: '',
      openAddPromo: false,
      isCheckingPromo: false,
      upcomingInvoice: {},
      coupon: {},
      inputCoupon: '',
      isRemoving: false,
      paymentType: 'disable',
      paymentObj: Pricing.typePayment,
      dataMyPlan: {},
      myPlanUrl: '',
      sourceParam: null,
      isShowPaypalFromCS: false,
      isShowPaypal: false,
      isPayPalButtonVisible: false,
      paypalBtn: null,
      isLatestInVoiceByStripe: false,
      isCapturingPaypalPayment: false,
      isShowingFurtherSupportText: false,
      cancellationOffer: null,
      CURRENCY,
      PAYMENT_METHOD,
      paymentOption: 'card',
      dataIdeal: {},
      idealLoading: false,
      loadingData: true,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    backToPresentation() {
      const backLink = Util.getParamValue('back_link_to_presentation', window.location.href)
      return backLink || ''
    },
    trace() {
      const trace = Util.getParamValue('trace', window.location.href)
      return trace || ''
    },

    translateTextUpgrade() {
      return this.$i18nPresenter.t(this.textUpgrade)
    },
    isOneTimeToSubscription() {
      return this.plan.group !== 'one-time' && this.$store.state.plan.group === 'one-time'
    },
    isAddReferenceCodeVisible() {
      return !this.openAddPromo && !this.promo &&
      !this.$store.state.currentUser.balance && !this.isOneTimeToSubscription
      && !this.cancellationOffer
    },
    placeholder_EnterCodeOptional() {
      return this.$i18nPresenter.t('Enter code (optional)')
    },
    getCurrency() {
      if (this.paymentOption === PAYMENT_METHOD.IDEAL) return CURRENCY.EUR
      if (this.currentUser.currency === USER_CURRENCY.EUR) return CURRENCY.EUR
      if (!this.currentUser.currency && this.currentUser.plan === USER_PLAN.FREE) return CURRENCY.USD
      if (!this.currentUser.currency && this.currentUser.plan !== USER_PLAN.FREE) return CURRENCY.USD
      return CURRENCY.USD
    },
    idealABtesting: {
      get() {
        if (!this.currentUser) return IDEAL_AB_TEST_GROUP.CONTROL
        if (!this.currentUser.abTest || !this.currentUser.abTest.IDEAL) {
          if (this.currentUser.currency === USER_CURRENCY.EUR) {
            // Với những thằng tài khoản cũ đã thanh toán ideal thì sẽ là TREATMENT
            return IDEAL_AB_TEST_GROUP.TREATMENT
          }
          return IDEAL_AB_TEST_GROUP.CONTROL
        }
        return IDEAL_AB_TEST_GROUP[this.currentUser.abTest.IDEAL]
      },
      set(value) {
        this.$store.state.currentUser.abTest.IDEAL = value
      },
    },
    isShowIdealPayment() {
      if (this.loadingData) {
        return false
      }
      if (this.idealABtesting === IDEAL_AB_TEST_GROUP.TREATMENT) {
        if (this.hasPaidInvoice && !this.currentUser.currency) {
          return false
        }
        return true
      }
      if (this.idealABtesting === IDEAL_AB_TEST_GROUP.CONTROL) {
        return false
      }
      if (!this.currentUser) return false
      if (!this.currentUser.country) return false
      return false
    },
    isShowCardPayment() {
      if (this.idealABtesting === IDEAL_AB_TEST_GROUP.TREATMENT) {
        return this.currentUser.currency !== USER_CURRENCY.EUR
      }
      if (this.idealABtesting === IDEAL_AB_TEST_GROUP.CONTROL) return true
      return true
    },
    isCardSectionCollapsed() {
      return this.paymentOption === PAYMENT_METHOD.IDEAL
    },
  },
  watch: {
    '$store.state.currentUser': function watchCurrentUser() {
      if (this.$store.state.currentUser.id) {
        this.getMyPlan()
        if (!this.$store.state.currentUser.currency) this.getStripeForm()
      }
    },
    paymentOption: async function onChangeCurrency() {
      const type = this.$route.params.id
      const method = this.paymentOption
      if (method === PAYMENT_METHOD.CARD) await this.getCustomerStripeForMethodCard(method)
      this.plan = Pricing.getPlanByType(type, method)
      this.loading = true
      this.getPaymentInformation()
    },
  },
  created() {
    const type = this.$route.params.id
    const isEuPlanRoute = /.*-eu$/.test(type)
    if (isEuPlanRoute) {
      this.$router.push({ name: 'Error404' })
    } else {
      this.plan = Pricing.getPlanByType(type)
      this.idealStatusHandler()
    }
  },
  async mounted() {
    this.domain = Config.domain
    const promo = Util.getParamValue('promo', window.location.href)
    if (promo) {
      if (promo === 'true') {
        this.isAddCoupon = true
      } else {
        this.promo = promo
      }
    } else {
      this.isAddCoupon = true
    }
    await this.getCurrentUserAction()
    await this.idealABTestHandler()
    if (Util.isOneTimePlan(this.$route.params.id) && this.currentUser.currency) this.$router.push({ name: 'Error404' })
    this.url = Config.presenterDomain
    this.myPlanUrl = `${Config.presenterDomain}/apps/user-plan/`

    if (this.$store.state.currentUser.id) {
      await this.checkInvoicePaid()
      this.setPaymentOption()
      this.getMyPlan()
      if (!this.$store.state.currentUser.currency) this.getStripeForm()
      else this.getIdealPaymentInfo()
      this.loadingData = false
    }
    this._addPaypalButton()
    this.isShowPaypalFromCS = Util.getParamValue('paypal', window.location.href) === 'true'
    if (this.isShowPaypalFromCS) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.handleClickPayViaPayPal()
        }, 2000)
      })
    }

    if (!this.plan) {
      window.location.href = `https://${this.domain}/pricing/`
      return
    }
    document.body.classList.add('pricing-page')

    await this._getInvoiceLatest()
    this.sourceParam = Util.getParamValue('source', window.location.href)
  },
  destroyed() {
    document.body.classList.remove('pricing-page')
  },
  methods: {
    ...mapActions([
      'getCurrentUserAction',
      'updateCurrentABTestAction',
    ]),
    viewAllPlan() {
      Util.mixpanelTracking('Upgrade Plan', 'View all plans', this.plan.type)
      window.open('/apps/user-plan', '_blank')
    },

    sendTrackingChangePaymentMethod(paymentMethod) {
      const method = paymentMethod === 'ideal' ? 'IDEAL' : 'Cards'
      Util.trackGA4AndMixpanel('select_payment_method', {
        eventAction: 'Select payment method',
        eventLabel: method,
        method,
      })
    },
    onChangePaymentOption(paymentMethod) {
      this.sendTrackingChangePaymentMethod(paymentMethod)
    },
    idealStatusHandler() {
      const { paymentSource, status } = this.$route.query
      if (paymentSource === 'iDEAL') {
        this.paymentOption = PAYMENT_METHOD.IDEAL
        if (status === 'success') {
          this.idealcheckoutSuccess()
        } else {
          this.idealcheckoutCancel()
          setTimeout(() => {
            Util.showToastError('iDEAL payment failed')
          }, 2000)
        }
      }
    },
    async callApiGetABTest(abTestCode) {
      try {
        return ABTestApi.getTest(abTestCode)
      } catch (e) {
        Sentry.captureException(e)
        return false
      }
    },
    async idealABTestHandler() {
      if (this.currentUser.country !== USER_COUNTRY.NETHERLANDS) {
        return
      }
      if (this.currentUser.plan !== USER_PLAN.FREE) {
        return
      }
      const userHaveABTestInformation = this.currentUser.abTest && this.currentUser.abTest.IDEAL
      if (userHaveABTestInformation) {
        return
      }

      const resGetAbTest = await this.callApiGetABTest(AB_TEST_CODE.IDEAL)
      if (!resGetAbTest || !resGetAbTest.body) {
        return
      }

      const { testCode, variant } = resGetAbTest.body
      const hasABTestData = testCode && variant
      if (!hasABTestData) {
        return
      }

      const newExperiment = {
        IDEAL: variant,
      }
      this.updateCurrentABTestAction(newExperiment)
      this.idealABtesting = variant
    },
    async _getInvoiceLatest() {
      const res = await InvoiceApi.getInvoices()
      if (res.invoices && res.invoices.length) {
        this.isLatestInVoiceByStripe = res.invoices[0].source === 'stripe'
      }
    },
    checkOutDonePaypal(params, transactionId) {
      // The payment has succeeded. Display a success message.
      this.$store.state.currentUser.plan = this.plan.type
      this.$store.state.plan = Pricing.getPlanByType(this.plan.type)
      this.doneUpgrade = true
      this.firework()
      window.scrollTo(0, 0)
      this.sendTrackingMakePaymentSuccess({
        eventLabel: 'Paypal',
        paymentType: this.paymentType,
        plan: this.plan,
        paidAmount: this.upcomingInvoice.total,
        credit: this.upcomingInvoice.credit,
        coupon: this.promo,
        invoiceId: transactionId,
      })

      this.isCheckout = false
      this.$http.post(Config.api.paymentHookSlack, {
        plan: this.plan.type,
        coupon: this.promo,
        total: this.upcomingInvoice.total,
        paymentSource: 'paypal',
      })

      this.isCapturingPaypalPayment = false

      Util.setupCapterraTracking()
    },
    _addPaypalButton() {
      const paypalScript = document.createElement('script')
      paypalScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${Config.paypalClientId}&disable-funding=credit,card`)
      document.head.appendChild(paypalScript)
    },
    handleClickPayWithPaypal() {
      this.showPaypalPayment()
    },
    async showPaypalPayment() {
      const self = this
      self.isPayPalButtonVisible = true

      if (self.paypalBtn) return
      self.paypalBtn = await window.paypal.Buttons({
        style: {
          color: 'gold',
          shape: 'pill',
          height: 40,
        },
        async createOrder() {
          // This function sets up the details of the transaction,
          // including the amount and line item details.
          const payload = {
            plan: self.plan.type,
          }

          if (self.promo) {
            payload.promo = self.promo
          }
          if (self.coupon && self.coupon.id) {
            payload.coupon = self.coupon.id.toUpperCase()
          }

          let data
          try {
            data = await PricingApi.paypalCreateOrder(payload)
          } catch (error) {
            const { body } = error
            let payPalErrObj = {}
            if (body && body.message) {
              try {
                payPalErrObj = JSON.parse(body.message)
                self.handlePaypalError(payPalErrObj)
                return null
              } catch (e) {
                self.handlePaypalError(error)
                return null
              }
            }
            self.handlePaypalError(error)
            return null
          }
          return data.body && data.body.orderID
        },
        async onApprove(data, actions) {
          let res = {}
          try {
            self.isCheckout = true
            self.isCapturingPaypalPayment = true
            res = await PricingApi.paypalCaptureOrder({
              orderID: data.orderID,
            })
          } catch (error) {
            const { body } = error
            let payPalErrObj = {}
            if (body && body.message) {
              try {
                payPalErrObj = JSON.parse(body.message)
              } catch (e) {
                self.handlePaypalError(e)
                return null
              }
            }
            if (payPalErrObj && payPalErrObj.details && payPalErrObj.details[0].issue === 'INSTRUMENT_DECLINED') {
              Util.mixpanelTracking(
                eventCategories.UPGRADE_PLAN,
                'Make payment > Failed',
                'Paypal',
                null,
                {
                  paymentStatus: 'failed',
                  paymentType: self.paymentType,
                  ...mixpanelUtils.getPlanContext(self.plan),
                },
              )
              // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
              return actions.restart()
            }
            self.handlePaypalError(error)
          }
          const { orderData, invoice, subscription } = res.body

          if (orderData.error) {
            self.handlePaypalError(orderData)
          }
          const params = {
            plan: self.plan.type,
          }
          if (self.promo) {
            params.promo = self.promo
          }
          if (self.plan.group === 'one-time') {
            self.checkOutDonePaypal(params, invoice && invoice.id)
          } else {
            self.checkOutDonePaypal(params, subscription && subscription.latest_invoice.id)
          }
        },
        onError(error) {
          if (error.body && error.body.message) {
            self.textError = `There is an error with your payment using PayPal: ${error.body.message}.`
          } else {
            self.textError = 'There is an error with your payment using PayPal.'
          }
          this.isShowingFurtherSupportText = true
          this.handlePaypalError(error)
        },
      })
      self.paypalBtn.render(self.$refs.paypal)
      self.isPayPalButtonVisible = true
    },
    handlePaypalError(err) {
      // Display error.message in your UI.
      this.textError =
        'We are experiencing difficulties in processing your payment using PayPal. Please make sure you have sufficient funds and try again. You can also try paying with a different card.'
      this.isShowingFurtherSupportText = true
      this.isCheckout = false
      this.hookSlack({
        plan: this.plan.type,
        total: this.upcomingInvoice.total,
        promo: this.promo,
        paymentSource: 'paypal',
        err: JSON.stringify((err && err.error) || err),
      })
      Util.mixpanelTracking(
        eventCategories.UPGRADE_PLAN,
        'Make payment > Failed',
        'Paypal',
        null, {
          paymentStatus: 'failed',
          paymentType: this.paymentType,
          ...mixpanelUtils.getPlanContext(this.plan),
        },
      )
      this.isCapturingPaypalPayment = false
    },
    // Ideal
    async idealcheckoutSuccess() {
      if (this.$store.state.currentUser.stripeSource === 'australia') {
        this.stripe = window.Stripe(Config.stripePublicKey)
      } else {
        this.stripe = window.Stripe(Config.singaporeStripePublishableKey)
      }

      const { session_id } = this.$route.query
      let dataInvoice = {}
      try {
        const resInvoice = await this.$http.get(Config.api.getInvoiceIdBySessionId, {
          params: {
            sessionId: session_id,
          },
        })
        dataInvoice = resInvoice.body
      } catch (e) {
        return false
      }
      const { invoiceId: transactionId, total, subTotal } = dataInvoice

      const plan = Pricing.getPlanByType(`${this.plan.type}`)
      this.$store.state.currentUser.plan = plan.type
      this.$store.state.plan = Pricing.getPlanByType(plan.type)
      this.plan = plan

      this.doneUpgrade = true
      this.alreadyUpgrade = false
      this.isCheckout = false
      setTimeout(() => {
        this.firework()
      }, 2000)

      const self = this
      self.upcomingInvoice = {
        total: total / 100,
        credit: (total - subTotal) / 100,
        couponAmount: 0,
      }

      self.sendTrackingMakePaymentSuccess({
        eventLabel: 'Stripe > iDEAL with SEPA',
        currency: 'EUR',
        paymentType: self.paymentType,
        plan: self.plan,
        paidAmount: self.upcomingInvoice.total,
        credit: self.upcomingInvoice.credit,
        coupon: this.promo,
        invoiceId: transactionId,
      })

      self.isCheckout = false
      self.$http.post(Config.api.paymentHookSlack, {
        plan: self.plan.type,
        coupon: self.promo,
        total: self.upcomingInvoice.total,
        paymentSource: PAYMENT_SOURCE.IDEAL,
      })

      Util.setupCapterraTracking()
    },

    idealUpdateSubcription() {
      const self = this
      const _submitIdealUpgradePlan = async function () {
        const payload = {
          plan: self.plan.type,
          userOldCard: self.userOldCard,
          total: self.upcomingInvoice.total,
        }
        if (self.promo) {
          payload.promo = self.promo
        }
        let data = {}
        try {
          data = await self.$http.post(Config.api.checkoutUpgradePlan, payload)
        } catch (err) {
          self.isCheckout = false
          if (err.body.err) {
            self.textError = err.body.err.raw.message
            self.isShowingFurtherSupportText = true
            self.hookSlack({
              plan: self.plan.type,
              total: self.upcomingInvoice.total,
              promo: self.promo,
              err: JSON.stringify(err.body.err),
              paymentSource: PAYMENT_SOURCE.IDEAL,
            })

            if (!self.isLatestInVoiceByStripe) {
              self.isShowPaypal = true
            }
          } else {
            self.textError =
              'Something went wrong.'
            self.isShowingFurtherSupportText = true
          }

          Util.mixpanelTracking(
            eventCategories.UPGRADE_PLAN,
            'Make payment > Failed',
            'Stripe > iDEAL with SEPA',
            null,
            {
              paymentStatus: 'failed',
              paymentType: self.paymentType,
              ...mixpanelUtils.getPlanContext(self.plan),
            },
          )
          return
        }

        if (data.body.err) {
          self.isCheckout = false
          return window.alert(
            'Something went wrong, please contact us for support',
          )
        }

        self.$store.state.currentUser.plan = self.plan.type
        self.$store.state.plan = Pricing.getPlanByType(
          self.plan.type,
        )
        self.isCheckout = false
        self.doneUpgrade = true
        self.firework()

        self.sendTrackingMakePaymentSuccess({
          eventLabel: 'Stripe > iDEAL with SEPA',
          currency: 'EUR',
          paymentType: self.paymentType,
          plan: self.plan,
          paidAmount: self.upcomingInvoice.total,
          credit: self.upcomingInvoice.proration,
          coupon: self.upcomingInvoice.couponAmount,
          invoiceId: data.body.invoice.id,
        })

        Util.setupCapterraTracking()
      }

      _submitIdealUpgradePlan()
    },
    idealCheckout() {
      if (this.isCheckout) {
        return
      }
      this.textError = ''
      this.isShowingFurtherSupportText = false
      this.isCheckout = true
      if (this.paymentType === 'update-subscription') {
        return this.idealUpdateSubcription()
      }

      const params = {
        planType: this.plan.type,
      }
      // eslint-disable-next-line promise/catch-or-return
      this.$http.post(Config.api.idealCheckout, params).then(
        (res) => {
          const { url } = res.body.data
          if (res.status === 200) window.location.href = url
          return res.status
        },
        () => {
          this.isCheckout = false
          this.textError =
            'Something went wrong.'
          this.isShowingFurtherSupportText = true
        },
      )
    },
    idealcheckoutCancel() {
      this.isCheckout = false
    },
    getStripeForm() {
      if (this.$store.state.currentUser.stripeSource === 'australia') {
        this.stripe = window.Stripe(Config.stripePublicKey)
      } else {
        this.stripe = window.Stripe(Config.singaporeStripePublishableKey)
      }

      const elementStyles = {
        base: {
          color: '#32325D',
          fontWeight: 500,
          fontSize: '16px',

          '::placeholder': {
            color: '#CFD7DF',
          },
          ':-webkit-autofill': {
            color: '#e39f48',
          },
        },
        invalid: {
          color: '#FF4954',

          '::placeholder': {
            color: '#FFCCA5',
          },
        },
      }

      const elementClasses = {
        focus: 'focused',
        empty: 'empty',
        invalid: 'invalid',
      }
      const elements = this.stripe.elements()
      this.card = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses,
      })
      this.card.mount('#card-number')

      this.cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses,
      })
      this.cardExpiry.mount('#card-expiry')

      this.cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses,
      })
      this.cardCvc.mount('#card-cvc')

      this.card.addEventListener('change', ({ error }) => {
        if (error) {
          this.textErrorCard = error.message
          this.isValidCard = false
        } else {
          this.isValidCard = true
          this.userOldCard = false
          this.textErrorCard = ''
        }
      })

      this.cardExpiry.addEventListener('change', ({ error }) => {
        if (error) {
          this.textErrorExpired = error.message
          this.isValidExpired = false
        } else {
          this.isValidExpired = true
          this.userOldCard = false
          this.textErrorExpired = ''
        }
      })

      this.cardCvc.addEventListener('change', ({ error }) => {
        if (error) {
          this.textErrorCvc = error.message
          this.isValidCvc = false
        } else {
          this.isValidCvc = true
          this.userOldCard = false
          this.textErrorCvc = ''
        }
      })
    },
    setPaymentOption() {
      if (this.idealABtesting === IDEAL_AB_TEST_GROUP.TREATMENT) {
        if (this.currentUser.currency === USER_CURRENCY.EUR) {
          this.paymentOption = PAYMENT_METHOD.IDEAL
        }

        if (this.currentUser.currency !== USER_CURRENCY.EUR && this.hasPaidInvoice) {
          // TH thuộc tệp test iDEAL, tuy nhiên khách đã thanh toán bằng CARD thì set default PaymentOption = 'Card'
          this.paymentOption = PAYMENT_METHOD.CARD
        }
        return
      }
      this.paymentOption = PAYMENT_METHOD.CARD
    },
    async checkInvoicePaid() {
      let resInvoicePaid
      try {
        resInvoicePaid = await this.$http
          .get(Config.api.checkInvoicePaid)
      } catch (e) {
        return
      }
      if (resInvoicePaid.body.hasPaid) {
        this.hasPaidInvoice = true
      }
    },
    getMyPlan() {
      if (this.$store.state.currentUser.plan === 'free') {
        this.getPaymentInformation()
        return
      }
      this.$http.get(Config.api.myPlan).then((res) => {
        this.dataMyPlan = res.body
        this.getPaymentInformation()
      })
    },
    removeCoupon() {
      const self = this
      if (this.isRemoving) return
      this.isRemoving = true
      this.inputCoupon = ''
      this.getPaymentInformation((data) => {
        self.formatInvoice(data)
        self.promo = ''
        self.openAddPromo = true
        self.isRemoving = false
      }, true)
    },
    checkPromotion() {
      const self = this
      if (this.isCheckingPromo) return
      this.isCheckingPromo = true
      this.promotionError = ''
      this.getPaymentInformation((data) => {
        if (data.coupon && data.coupon.id) {
          self.formatInvoice(data)
          self.promo = data.coupon.id
          self.openAddPromo = false
        } else if (data.invalidCoupon) {
          self.promotionError = self.$i18nPresenter.t('This code has expired.')
        } else {
          self.promotionError = self.$i18nPresenter.t('Invalid code, please try again.')
        }
        self.isCheckingPromo = false
      })
    },
    showInputPromo() {
      this.openAddPromo = true
    },
    checkDisableCheckout() {
      if (this.isCheckout || this.loading) {
        return true
      }
      if (this.userOldCard) {
        return false
      }
      if (!this.isValidCard || !this.isValidCvc || !this.isValidCvc) {
        return true
      }
      return false
    },
    idealCheckDisableCheckout() {
      if (this.isCheckout || this.loading) return true
      return false
    },
    async getCustomerStripeForMethodCard(paymentOption) {
      if (this.$store.state.currentUser.plan === USER_PLAN.FREE && this.$store.state.currentUser.stripeCustomerId) {
        const resCustomerStripe = await this.$http.get(`${Config.api.getCustomerStripeForMethodCard}?paymentOption=${paymentOption}`)
        if (resCustomerStripe.body.status === 2) {
          this.$store.state.currentUser.stripeCustomerId = resCustomerStripe.body.stripeCustomerId
        }
      }
    },
    getPaymentInformation(callback, isRemove) {
      const { paymentSource, status } = this.$route.query
      if (paymentSource === 'iDEAL' && status === 'success') {
        this.loading = false
        return
      }
      if (this.plan.type === this.$store.state.currentUser.plan) {
        this.alreadyUpgrade = true
        this.loading = false
        return
      }

      const query = {
        plan: this.plan.type,
      }

      if (this.promo && !isRemove) {
        query.coupon = this.promo
        if (this.paymentOption === PAYMENT_METHOD.IDEAL) {
          query.coupon = undefined
        }
      }
      if (callback) {
        this.inputCoupon = this.inputCoupon.trim()
        query.coupon = this.inputCoupon
      }
      if (query.coupon) {
        query.coupon = query.coupon.toUpperCase()
      }
      this.$http
        .get(Config.api.getDetailPricing, {
          params: query,
        })
        .then(
          (res) => {
            if (callback) {
              callback(res.body)
              return
            }

            this.paymentType = res.body.paymentType
            if (res.body.card) {
              this.currentCard = res.body.card
              if (!res.body.card.id) {
                this.userOldCard = false
              }
            } else {
              this.userOldCard = false
            }
            this.formatInvoice(res.body)

            this.loading = false
            this._checkTextUpgrade()
          },
          () => {
            this.paymentType = ''
            this.loading = false
          },
        )
    },
    getIdealPaymentInfo() {
      if (this.$store.state.currentUser.plan === 'free') return
      this.idealLoading = true
      this.$http.get(Config.api.getIdealPaymentMethod).then((data) => {
        this.dataIdeal = data.body.data
        this.idealLoading = false
      })
    },
    formatInvoice(res) {
      const data = JSON.parse(JSON.stringify(res))
      let subtotal = 0
      let total = 0
      let couponAmount = 0
      let credit = 0
      let proration = 0
      if (data.coupon) {
        this.coupon = data.coupon
        // AHA-7710 Show the auto-offer for cancellation if exists
        if (this.isCancellationOffer(data.coupon)) {
          this.cancellationOffer = data.coupon
        }
      } else {
        this.promo = ''
      }
      if (
        data.paymentType === Pricing.typePayment.createNewSubscrition ||
        data.paymentType === Pricing.typePayment.createNewOneTime
      ) {
        this.isLatestInVoiceByStripe = false
        if (!data.balance) data.balance = 0
        if (data.balance) {
          data.balance = parseFloat(Util.roundNumber(data.balance / 100))
          this.upcomingInvoice.credit = data.balance
        }
        if (data.coupon) {
          if (data.coupon.amount_off) {
            subtotal = parseFloat(this.plan.price)
            couponAmount = Util.roundNumber(this.coupon.amount_off / 100)
            total = Util.roundNumber(subtotal - couponAmount + data.balance)
            if (total < 0) {
              total = 0.00
              this.upcomingInvoice.credit = Util.roundNumber(0 - subtotal - couponAmount)
            }
          } else {
            subtotal = parseFloat(this.plan.price)
            couponAmount = Util.roundNumber(
              (this.plan.price / 100) * this.coupon.percent_off,
            )
            total = Util.roundNumber(subtotal - couponAmount + data.balance)
            if (total < 0) {
              total = 0.00
              this.upcomingInvoice.credit = Util.roundNumber(0 - subtotal - couponAmount)
            }
          }
        } else {
          subtotal = parseFloat(this.plan.price)
          total = Util.roundNumber(parseFloat(this.plan.price) + data.balance)
          if (total < 0) {
            total = 0.00
            this.upcomingInvoice.credit = Util.roundNumber(0 - subtotal)
          }
        }

        if (this.$store.state.plan.group !== 'free' && data.paymentType === Pricing.typePayment.createNewOneTime) {
          this.textUpgrade = 'Buy now'
        }
      } else if (data.paymentType === Pricing.typePayment.updateOneTime) {
        subtotal = data.subtotal
        credit = data.credit
        total = data.total
        couponAmount = data.couponAmount
      } else if (data.paymentType === Pricing.typePayment.updateSubscription) {
        // Dont allow user to upgrade from non-edu Yearly plan -> Edu plan
        if (this.$store.state.plan.group !== 'edu' && this.$store.state.plan.billingCycle === 'yearly' && this.plan.group === 'edu') {
          this.paymentType = null
          return
        }
        subtotal = data.subtotal
        proration = data.proration
        total = data.total
        couponAmount = data.couponAmount
        if (proration) {
          let amountApply = parseFloat(this.plan.price) + parseFloat(proration)
          if (!this.$store.state.currentUser.balance && amountApply < 0) {
            this.paymentType = ''
          } else {
            amountApply = parseFloat(this.plan.price) + parseFloat(proration) -
              this.$store.state.currentUser.balance / 100
            if (amountApply < 0) {
              this.paymentType = ''
            }
            if (data.total == 0 && !this.isCancellationOffer(data.coupon)) {
              proration = 0 - parseFloat(this.plan.price)
            }
          }
        }
        this.isSubscription = true
      } else if (
        data.paymentType ===
        Pricing.typePayment.createNewSubscriptionRemoveOneTime
      ) {
        subtotal = data.subtotal
        credit = data.credit
        total = data.total
        this.coupon = {}
        this.isSubscription = true

        if (this.$store.state.plan.type === 'one-time-medium' && this.plan.type === 'essential-monthly') {
          this.paymentType = ''
        }
        if (this.$store.state.plan.type === 'one-time-large' &&
        (this.plan.type === 'essential-monthly' || this.plan.type === 'plus-monthly')) {
          this.paymentType = ''
        }
      }

      if (total < 0) {
        total = 0.0
      }

      if (couponAmount > 0) {
        couponAmount = 0 - couponAmount
      }
      if (credit > 0) {
        credit = 0 - credit
      }
      if (couponAmount > 0) {
        proration = 0 - proration
      }

      this.upcomingInvoice.subtotal = Util.roundNumber(subtotal)
      this.upcomingInvoice.total = Util.roundNumber(total)
      if (couponAmount) {
        this.upcomingInvoice.couponAmount = Util.roundNumber(couponAmount)
      }
      if (credit) {
        this.upcomingInvoice.credit = Util.roundNumber(credit)
      }
      if (proration) {
        this.upcomingInvoice.proration = Util.roundNumber(proration)
      }
    },

    _checkTextUpgrade() {
      if (this.$store.state.plan.group === 'plus' && this.plan.group === 'essential') {
        this.textUpgrade = 'OK'
      }

      if (this.$store.state.plan.group === 'pro' && (this.plan.group === 'essential' || this.plan.group === 'plus')) {
        this.textUpgrade = 'OK'
      }

      if (this.$store.state.plan.group === this.plan.group && this.$store.state.plan.billingCycle === 'yearly' && this.plan.billingCycle === 'monthly') {
        this.textUpgrade = 'OK'
      }

      if (this.$store.state.plan.type === 'one-time-small' && this.plan.type === 'one-time-mini') {
        this.paymentType = ''
      }

      if (this.$store.state.plan.type === 'one-time-medium' && (this.plan.type === 'one-time-mini' || this.plan.type === 'one-time-small')) {
        this.paymentType = ''
      }
      if (this.$store.state.plan.type === 'one-time-large' && (this.plan.type === 'one-time-mini' || this.plan.type === 'one-time-small' || this.plan.type === 'one-time-medium')) {
        this.paymentType = ''
      }
    },

    firework() {
      const self = this
      const canvas = document.getElementById('firework-canvas')
      if (!canvas) return
      canvas.confetti =
        canvas.confetti ||
        confetti.create(canvas, {
          resize: true,
        })
      const colors = Constant.colorsHex.filter((item, key) => {
        return item && key < 7
      })

      const _startFirework = function startFirework() {
        let start = null
        let count = 0
        let timeFirework = 250
        // eslint-disable-next-line
        function step(timestamp) {
          if (count === 3) {
            timeFirework = 800
          }
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > timeFirework) {
            start = null
            count++
            canvas.confetti({
              startVelocity: 5,
              spread: 360,
              ticks: 200,
              decay: 0.98,
              particleCount: 80,
              shapes: ['circle'],
              colors,
              zIndex: 100,
              origin: {
                x: Math.random(),
                // since they fall down, start a bit higher than random
                y: Math.random() - 0.3,
              },
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
      _startFirework(false)
    },

    checkout() {
      this.isShowingFurtherSupportText = false
      this.textError = ''
      if (this.isCheckout) return
      this.isCheckout = true
      const self = this

      if (
        this.paymentType == Pricing.typePayment.createNewSubscrition ||
        this.paymentType == Pricing.typePayment.createNewOneTime
      ) {
        const _checkOutDone = function (params, transactionId) {
          // The payment has succeeded. Display a success message.
          // Called when buy/upgrade subscription w default card or onetime w authentication required card
          self.$store.state.currentUser.plan = self.plan.type
          self.$store.state.plan = Pricing.getPlanByType(self.plan.type)
          self.doneUpgrade = true
          self.firework()
          window.scrollTo(0, 0)

          self.sendTrackingMakePaymentSuccess({
            eventLabel: 'Stripe > Cards',
            paymentType: self.paymentType,
            plan: self.plan,
            paidAmount: self.upcomingInvoice.total,
            credit: self.upcomingInvoice.credit,
            coupon: self.upcomingInvoice.couponAmount,
            invoiceId: transactionId,
          })

          self.isCheckout = false
          self.$http.post(Config.api.paymentHookSlack, {
            plan: self.plan.type,
            coupon: self.promo,
            total: self.upcomingInvoice.total,
          })

          Util.setupCapterraTracking()
        }
        const _confirmCheckout = function (clientSecret, params, checkOutResponse) {
          self.stripe.confirmCardPayment(clientSecret).then((result) => {
            if (result.error) {
              // Display error.message in your UI.
              self.textError =
                'We are experiencing difficulties in processing your payment using your entered card. Please make sure you have sufficient funds and try again. You can also try paying with a different card.'
              self.isShowingFurtherSupportText = true
              self.isCheckout = false
              self.hookSlack({
                plan: self.plan.type,
                total: self.upcomingInvoice.total,
                promo: self.promo,
                err: JSON.stringify(result.error),
              })
              self.isShowPaypal = true
            } else if (self.plan.group === 'one-time') {
              const payloadConfirmCheckout = {
                id: params.paymentIntentId,
              }
              if (self.coupon) {
                payloadConfirmCheckout.coupon = self.coupon
              }
              self.$http
                .post(Config.api.confirmCheckout, payloadConfirmCheckout)
                .then(
                  () => {
                    _checkOutDone(params, checkOutResponse.id)
                  },
                  (err) => {
                    self.isCheckout = false
                    self.textError = err.body.message
                    self.isShowingFurtherSupportText = true
                  },
                )
            } else {
              _checkOutDone(params, checkOutResponse.subscription.latest_invoice.id)
            }
          })
        }

        const _handleCheckoutNewPlan = function (paymentMethod) {
          const params = {
            plan: self.plan.type,
            userOldCard: self.userOldCard,
          }
          if (self.promo) {
            params.promo = self.promo
          }
          if (paymentMethod) {
            params.payment_method = paymentMethod.id
          }

          self.$http.post(Config.api.checkout, params).then(
            (res) => {
              if (res.body.err) {
                self.textError = res.body.err
                self.isShowingFurtherSupportText = true
                self.isCheckout = false
                return
              }

              if (self.plan.group == 'one-time') {
                if (res.body.status == 'paid') {
                  _checkOutDone(params, res.body.id)
                } else {
                  params.paymentIntentId = res.body.paymentIntentObj.id
                  _confirmCheckout(res.body.paymentIntentObj.client_secret, params, res.body)
                }
              } else if (res.body.subscription.status == 'active') {
                _checkOutDone(params, res.body.subscription.latest_invoice.id)
              } else if (
                res.body.subscription.latest_invoice &&
                    res.body.subscription.latest_invoice.payment_intent &&
                    res.body.subscription.latest_invoice.payment_intent
                      .client_secret
              ) {
                _confirmCheckout(
                  res.body.subscription.latest_invoice.payment_intent
                    .client_secret,
                  params,
                  res.body,
                )
              }
            },
            (err) => {
              if (err.body.err) {
                self.textError = err.body.err.raw.message
                self.isShowingFurtherSupportText = true
                self.isCheckout = false
                self.hookSlack({
                  plan: self.plan.type,
                  total: self.upcomingInvoice.total,
                  promo: self.promo,
                  err: JSON.stringify(err.body.err),
                })
                Util.mixpanelTracking(
                  eventCategories.UPGRADE_PLAN,
                  'Make payment > Failed',
                  'Stripe > Cards',
                  null,
                  {
                    paymentStatus: 'failed',
                    paymentType: self.paymentType,
                    ...mixpanelUtils.getPlanContext(self.plan),
                  },
                )
                self.isShowPaypal = true
              }
            },
          )
          // Handle result.error or result.paymentMethod
        }
        if (!self.userOldCard) {
          self.stripe
            .createPaymentMethod({
              type: 'card',
              card: self.card,
            })
            .then((result) => {
              if (result.error) {
                self.isCheckout = false
                self.textError = result.error.message
                self.isShowingFurtherSupportText = true
                self.hookSlack({
                  plan: self.plan.type,
                  total: self.upcomingInvoice.total,
                  promo: self.promo,
                  err: JSON.stringify(result.error),
                })
                Util.mixpanelTracking(
                  eventCategories.UPGRADE_PLAN,
                  'Make payment > Failed',
                  'Stripe > Cards',
                  null,
                  {
                    paymentStatus: 'failed',
                    paymentType: self.paymentType,
                    ...mixpanelUtils.getPlanContext(self.plan),
                  },
                )
                if (!self.isLatestInVoiceByStripe) {
                  self.isShowPaypal = true
                }
              } else if (result.paymentMethod) {
                const { paymentMethod } = result
                _handleCheckoutNewPlan(paymentMethod)
              }
            })
        } else {
          _handleCheckoutNewPlan()
        }
      } else {
        // UPGRADE PLAN CHECKOUT
        const _submitUpgradePlan = function (paymentMethod) {
          const payload = {
            plan: self.plan.type,
            userOldCard: self.userOldCard,
            total: self.upcomingInvoice.total,
          }
          if (paymentMethod) {
            payload.paymentMethodId = paymentMethod.id
          }
          if (self.promo) {
            payload.promo = self.promo
          }
          self.$http.post(Config.api.checkoutUpgradePlan, payload).then(
            (data) => {
              if (data.body.err) {
                self.isCheckout = false
                return window.alert(
                  'Something went wrong, please contact us for support',
                )
              }
              // Called when upgrade one time with default/authentication required card
              const _doneUpdated = function (transactionId) {
                self.$store.state.currentUser.plan = self.plan.type
                self.$store.state.plan = Pricing.getPlanByType(self.plan.type)
                self.doneUpgrade = true
                self.firework()

                self.sendTrackingMakePaymentSuccess({
                  eventLabel: 'Stripe > Cards',
                  paymentType: self.paymentType,
                  plan: self.plan,
                  paidAmount: self.upcomingInvoice.total,
                  credit: self.upcomingInvoice.credit,
                  coupon: self.upcomingInvoice.couponAmount,
                  invoiceId: transactionId,
                })

                self.$http
                  .post(Config.api.paymentHookSlack, {
                    plan: self.plan.type,
                    total: self.upcomingInvoice.total,
                    promo: self.promo,
                  })
                  .then(() => {})
                self.isCheckout = false

                Util.setupCapterraTracking()
              }

              const _confirmPayment = function (clientSecret, params) {
                self.stripe
                  .confirmCardPayment(clientSecret)
                  .then((result) => {
                    if (result.error) {
                      // Display error.message in your UI.
                      self.textError = result.error.message
                      self.isShowingFurtherSupportText = true
                      self.isCheckout = false
                      self.hookSlack({
                        plan: self.plan.type,
                        total: self.upcomingInvoice.total,
                        promo: self.promo,
                        err: JSON.stringify(result.error),
                      })
                      Util.mixpanelTracking(
                        eventCategories.UPGRADE_PLAN,
                        'Make payment > Failed',
                        'Stripe > Cards',
                        null,
                        {
                          paymentStatus: 'failed',
                          paymentType: self.paymentType,
                          ...mixpanelUtils.getPlanContext(self.plan),
                        },
                      )
                      if (!self.isLatestInVoiceByStripe) {
                        self.isShowPaypal = true
                      }
                    } else if (self.plan.group === 'one-time') {
                      // The payment has succeeded. Display a success message.
                      const payloadConfirmCheckout = {
                        id: params.paymentIntentObj.id,
                      }
                      if (self.coupon) {
                        payloadConfirmCheckout.coupon = self.coupon
                      }
                      self.$http
                        .post(
                          Config.api.confirmCheckout,
                          payloadConfirmCheckout,
                        )
                        .then(
                          () => {
                            _doneUpdated(params.id)
                          },
                          (err) => {
                            self.isCheckout = false
                            self.textError = err.body.message
                            self.isShowingFurtherSupportText = true
                          },
                        )
                    } else {
                      _doneUpdated(params.subscription.latest_invoice.id)
                    }
                  })
              }

              if (self.plan.group === 'one-time') {
                // if (data.body.status == "succeeded") {
                //   _doneUpdated();
                // } else {
                //   _confirmPayment(data.body.client_secret, data.body);
                // }

                if (data.body.status === 'paid') {
                  _doneUpdated(data.body.id)
                } else {
                  _confirmPayment(data.body.paymentIntentObj.client_secret, data.body)
                }
                return
              }
              if (
                self.paymentType ==
                  self.paymentObj.createNewSubscriptionRemoveOneTime
              ) {
                // Onetime upgrade to subscription
                if (data.body.subscription.status === 'active') {
                  _doneUpdated(data.body.subscription.latest_invoice.id)
                } else if (
                  data.body.subscription.latest_invoice &&
                      data.body.subscription.latest_invoice.payment_intent &&
                      data.body.subscription.latest_invoice.payment_intent
                        .client_secret
                ) {
                  _confirmPayment(
                    data.body.subscription.latest_invoice.payment_intent
                      .client_secret,
                    data.body,
                  )
                }
                return
              }
              // Called when upgrade subscription\
              if (data.body.invoice.status === 'paid' || data.body.upgradeSubHasPromo || self.$store.state.currentUser.currency === 'eur') {
                self.$store.state.currentUser.plan = self.plan.type
                self.$store.state.plan = Pricing.getPlanByType(
                  self.plan.type,
                )
                self.isCheckout = false
                self.doneUpgrade = true
                self.firework()

                self.sendTrackingMakePaymentSuccess({
                  eventLabel: 'Stripe > Cards',
                  paymentType: self.paymentType,
                  plan: self.plan,
                  paidAmount: self.upcomingInvoice.total,
                  credit: self.upcomingInvoice.proration,
                  coupon: self.upcomingInvoice.couponAmount,
                  invoiceId: data.body.invoice.id,
                })

                Util.setupCapterraTracking()
              } else if (data.body.invoice.status === 'open') {
                self.stripe
                  .confirmCardPayment(data.body.paymentIntent.client_secret)
                  .then((result) => {
                    if (result.error) {
                      // Display error.message in your UI.
                      self.textError = result.error.message
                      self.isShowingFurtherSupportText = true
                      self.isCheckout = false
                      self.hookSlack({
                        plan: self.plan.type,
                        total: self.upcomingInvoice.total,
                        promo: self.promo,
                        err: JSON.stringify(result.error),
                      })
                      Util.mixpanelTracking(
                        eventCategories.UPGRADE_PLAN,
                        'Make payment > Failed',
                        'Stripe > Cards',
                        null,
                        {
                          paymentStatus: 'failed',
                          paymentType: self.paymentType,
                          ...mixpanelUtils.getPlanContext(self.plan),
                        },
                      )
                      if (!self.isLatestInVoiceByStripe) {
                        self.isShowPaypal = true
                      }
                    } else {
                      // The payment has succeeded. Display a success message.
                      // Called when upgrade subscription with Authentication required card
                      self.$store.state.currentUser.plan = self.plan.type
                      self.$store.state.plan = Pricing.getPlanByType(
                        self.plan.type,
                      )
                      self.doneUpgrade = true
                      self.firework()

                      self.sendTrackingMakePaymentSuccess({
                        eventLabel: 'Stripe > Cards',
                        paymentType: self.paymentType,
                        plan: self.plan,
                        paidAmount: self.upcomingInvoice.total,
                        credit: self.upcomingInvoice.proration,
                        coupon: self.upcomingInvoice.couponAmount,
                        invoiceId: data.body.invoice.id,
                      })

                      self.$http
                        .post(Config.api.paymentHookSlack, {
                          plan: self.plan.type,
                          total: self.upcomingInvoice.total,
                          promo: self.promo,
                        })
                        .then(() => {})
                      self.isCheckout = false

                      Util.setupCapterraTracking()
                    }
                  })
              }
            },
            (err) => {
              self.isCheckout = false
              if (err.body.err) {
                self.textError = err.body.err.raw.message
                self.isShowingFurtherSupportText = true
                self.hookSlack({
                  plan: self.plan.type,
                  total: self.upcomingInvoice.total,
                  promo: self.promo,
                  err: JSON.stringify(err.body.err),
                })

                if (!self.isLatestInVoiceByStripe) {
                  self.isShowPaypal = true
                }
              } else {
                self.textError =
                  'Something went wrong.'
                self.isShowingFurtherSupportText = true
              }

              Util.mixpanelTracking(
                eventCategories.UPGRADE_PLAN,
                'Make payment > Failed',
                'Stripe > Cards',
                null,
                {
                  paymentStatus: 'failed',
                  paymentType: self.paymentType,
                  ...mixpanelUtils.getPlanContext(self.plan),
                },
              )
            },
          )
        }

        if (!self.userOldCard) {
          self.stripe
            .createPaymentMethod({
              type: 'card',
              card: self.card,
            })
            .then((result) => {
              if (result.error) {
                self.isCheckout = false
                self.textError = result.error.message
                self.isShowingFurtherSupportText = true
                self.hookSlack({
                  plan: self.plan.type,
                  total: self.upcomingInvoice.total,
                  promo: self.promo,
                  err: JSON.stringify(result.error),
                })

                Util.mixpanelTracking(
                  eventCategories.UPGRADE_PLAN,
                  'Make payment > Failed',
                  'Stripe > Cards',
                  null, {
                    paymentStatus: 'failed',
                    paymentType: self.paymentType,
                    ...mixpanelUtils.getPlanContext(self.plan),
                  },
                )
                if (!self.isLatestInVoiceByStripe) {
                  self.isShowPaypal = true
                }
              } else if (result.paymentMethod) {
                const { paymentMethod } = result
                _submitUpgradePlan(paymentMethod)
              }
            })
        } else {
          _submitUpgradePlan()
        }
      }
    },

    hookSlack(payload) {
      this.$http.post(Config.api.paymentHookSlack, payload).then(() => {})
    },

    goToMyPresentations() {
      // Dont use vue-router here, to clean up state and reload full page.

      if (this.backToPresentation.length > 0) {
        return this.$func.go(`${this.backToPresentation}`)
      }
      this.$func.go(`${Config.presenterDomain}/apps/presentations`)
    },

    handleClickPayViaPayPal() {
      document.documentElement.scrollTo({
        top: 100,
        behavior: 'smooth',
      })

      if (this.isPayPalButtonVisible) return
      this.isPayPalButtonVisible = true
      setTimeout(() => {
        this.showPaypalPayment()
      })
    },

    openChat() {
      zoho.openChat()
    },

    redirectToMyPlan() {
      window.location.href = this.myPlanUrl
    },

    isCancellationOffer(coupon) {
      return coupon && coupon.metadata && coupon.metadata.offer_on_cancellation === 'true'
    },

    trackRevenueAfterCheckoutDone(data) {
      mixpanelUtils.trackCharge(parseFloat(data.paidAmount), mixpanelUtils.getChargeContext(data))
    },

    async sendTrackingMakePaymentSuccess(data) {
      const {
        eventLabel, paymentType, plan, paidAmount, credit, coupon,
        currency = 'USD',
      } = data
      const chargeContext = mixpanelUtils.getChargeContext({
        paidAmount,
        credit,
        coupon,
      })
      Util.mixpanelTracking(
        eventCategories.UPGRADE_PLAN,
        'Make payment',
        eventLabel,
        '',
        {
          paymentStatus: 'succeed',
          paymentType,
          ...chargeContext,
          ...mixpanelUtils.getPlanContext(plan),
        },
      )
      const res = await InvoiceApi.getInvoices()
      let invoiceID = ''
      if (res.invoices && res.invoices.length) {
        invoiceID = res.invoices[0].invoiceId
      }
      const dataGa4 = {
        eventAction: 'purchase',
        currency,
        payment_method: eventLabel,
        transaction_id: `${invoiceID}`,
        value: chargeContext.paidAmount,
        coupon: this.promo,
        tax: 0,
        items: [{
          item_name: plan.name,
          discount: chargeContext.discountWithCredit,
          item_category: plan.group,
          coupon: this.promo,
          item_category2: plan.billingCycle ? plan.billingCycle : 'one-time',
          item_category3: paymentType,
          item_variant: this.sourceParam === 'pricing' ? 'Landing site' : 'Presenter app',
        }],
      }
      Util.trackGA4AndMixpanel('purchase', dataGa4)
      this.trackRevenueAfterCheckoutDone({
        paidAmount,
        credit,
        coupon,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/animation.scss";
.upgrade-page {
  max-width: 1024px;
  @apply mx-auto;
}
.fa-trash-alt {
  cursor: pointer;
}
.add-promotion {
  .label-promotion {
    cursor: pointer;
    margin: -18px 0 12px;
  }

  input.form-control {
    border-radius: 5px;
    padding-right: 100px;

    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      text-transform: none;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      text-transform: none;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      text-transform: none;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      text-transform: none;
    }
  }
  .box-promo {
    position: relative;
    margin-bottom: 4px;

    button.btn {
      position: absolute;
      width: 86px;
      height: 36px;
      font-size: 14px;
      top: 4px;
      right: 6px;
    }
  }
}

.line-invoice.line-invoice-promo {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin-bottom: 12px;
  padding-top: 12px;
  margin-top: 12px;
  padding-bottom: 16px;
  .line-value.flex.total-value {
    font-size: 17px;
    font-weight: bold;
  }
  .value-coupon {
    color: $success-color;
  }
  p {
    margin-bottom: 0;
    font-size: 14px;
    color: #888;
  }
}
.secure-notice {
  color: #479a47;
  padding-left: 0.5rem;
  .fas {
    color: inherit;
  }
}
.card-error-text {
  color: #FF4954;
  margin-top: -10px;
}
.show-existing-card {
  font-weight: normal;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 17px;
  margin-bottom: 24px;
  border-radius: 5px;
  cursor: pointer;

  &.active {
    border-color: $primary-color;

    i {
      color: $primary-color;
    }
  }

  i {
    margin-right: 10px;
  }
}
h5 {
  font-weight: bold;
  font-size: 17px;
}
.card-collapsed {
  visibility: collapse;
  height: 0;
}
.card-form {
  font-weight: bold;
  padding: 18px;
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 16px;

  h4 {
    font-weight: bold;
  }
  .label-card {
    margin-bottom: 2px;
    color: #666;
  }
  .card-form--label {
    @apply block mb-1 text-base-80 text-base;
    font-size: 1rem;

  }
  @media screen and (min-width:480px) {
    padding: 24px;
  }
}

#card-number,
#card-expiry,
#card-cvc {
  border: 1px solid #ddd;
  height: 40px;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 8px;
}

.power-by {
  @apply flex flex-row items-center justify-center;
  min-height: 34px;

  .card-img-logo {
    max-width: 300px;
    margin-bottom: 8px;
    display: block;
  }

  .paypal-stripe__wrapper {
    @apply flex;
    img {
      margin-bottom: 8px;
      display: block;
      width: 138px;
      position: relative;
    }
  }

  .power-by-paypal {
    @apply pl-2;
    img {
      height: 34px;
      width: auto;
    }
  }

  @media (max-width: 767px) {
    @apply block;
    .card-img-logo__wrapper {
      @apply w-full;
    }
    .paypal-stripe__wrapper {
      max-width: 235px;
      margin: 0 auto;
    }

    a {
      margin: 0 auto;
    }

    img {
      margin: 0 auto;
    }
  }
}

.power-by-hidden {
  display: none;
}

.content-plan {
  min-height: 300px;
  .text-loading .fas {
    font-size: 12px;
  }
}
canvas#firework-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  pointer-events: none;
}

.text-error {
  max-width: 400px;
}
h2 {
  text-align: center;
  font-weight: bold;
  font-size: 30px;
}

.ui-layout {
  max-width: 1036px;
  min-height: 300px;
  margin: 0 auto;
}

.ui-card {
  background-color: #ffffff;
  padding: 20px;
  height: auto;
}

.loading-wrapper {
  width: 100%;
}
.title-block {
  padding-bottom: 24px;
  padding-top: 8px;
}
.title-upgrade {
  @apply my-10 px-4;
  line-height: 2.25rem;
}
.cannot-upgrade-des {
  @apply text-base mb-2;
}
.list-block {
  padding-top: 12px;
}

.loading {
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeHolderShimmer;
  -webkit-animation-timing-function: linear;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background-image: -webkit-gradient(
    linear,
    left center,
    right center,
    from(#f6f7f8),
    color-stop(0.2, #edeef1),
    color-stop(0.4, #f6f7f8),
    to(#f6f7f8)
  );
  background-image: -webkit-linear-gradient(
    left,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  border-radius: 2px;

  &.title {
    height: 10px;
    width: 25%;
    margin-bottom: 28px;
  }

  &.content {
    height: 10px;
    margin-bottom: 12px;
    &.line-item {
      margin-bottom: 28px;
    }
  }
  &.last-row {
    width: 90%;
    margin-bottom: 0px;
  }
  &.ideal {
    height: 0.5rem;
    margin-bottom: 0.5rem;
  }
}

.content-plan {
  .congrats-text {
    font-size: 16px;
    margin-bottom: 32px;
  }

  .congrats-upgrade {
    margin-bottom: 16px;
  }

  .line-invoice {
    @apply flex flex-row justify-between py-1;
    font-size: 17px;

    .line-label {
      font-weight: bold;
      color: rgba(37, 43, 54, 0.75);
      padding-right: 8px;
    }
    .line-value {

      text-align: right;
      overflow: hidden;
      word-break: break-word;
      &.total-value {
        font-size: 21px;
      }
    }
    .flash-discount {
      @apply text-green-50;
    }

    &.total {
      margin: 16px 0;
      font-weight: bold;

      .line-label {
        color: #000;
      }

      .line-value {
        color: $primary-color;
      }
    }

    &.proration {
      .line-label {
        @apply text-green-50;

      }

      .line-value {
        @apply text-green-50;
      }
    }
  }

  button.btn {
    max-width: 300px;
    width: 100%;
    margin: 0 auto 16px auto;
    font-weight: bold;
    height: 44px;
    font-size: 16px;
  }
}
.upgrade-success-content {
  button.btn {
    margin-bottom: 80px;
  }
  button {
    margin: 0 auto;
  }

  button.btn {
    max-width: 300px;
    width: 100%;
    margin: 0 auto 16px auto;
    font-weight: bold;
    height: 44px;
    font-size: 16px;
  }
}
.more-information {
  @apply p-4 md:p-6;
  max-width: 1024px;
  margin: 0 auto;
  p {
    margin-bottom: 8px;
  }
  .item-information {
    margin-bottom: 16px;
  }
}
.add-coupon-wrapper {
  @apply relative;
  &:hover ::v-deep .aha-input {
    @apply bg-primary-20 border-primary-90;
  }
}
.add-coupon-input {
  ::placeholder { /* Recent browsers */
      text-transform: none;
  }
}

.upgrade-section {
  @apply w-full md:w-1/2 lg:w-5/12 px-5;
  @media screen and (min-width: 1024px) {
    max-width: 420px;
  }
  &.form-section {
    @apply mb-4 md:mb-0;
  }
}

.upgrade-btn {
  @apply w-full;

  // this fix weird flickering when hovering to Upgrade button
  .btn-upgrade--text {
    &.btn-upgrade--text-ok {
     min-width: 24px;
    }
    &.btn-upgrade--text-buy {
     min-width: 66px;
    }
    &.btn-upgrade--text-upgrade {
     min-width: 66px;
    }
  }

}

.add-btn {
  min-width: 1.5rem;
}

.paypal-btn {
  @apply pt-3;
  &.disabled {
    @apply opacity-50 cursor-not-allowed pointer-events-none;
  }
}

.info-box-error {
  @apply mt-4 text-error;
}

.paypal__wrapper-text {
  @apply flex items-center mt-4 pl-1;
}

@media (max-width: 767px) {
  .paypal-btn, .upgrade-btn {
    max-width: 300px;
  }
  .paypal__wrapper-text, .secure-notice {
    max-width: 400px;
  }
  .info-box-error, .paypal__wrapper-text {
    @apply mx-auto;
  }
  .paypal-btn {
    @apply my-0 mx-auto;
  }
}
.text-black-100 {
  color: rgba(0, 0, 0, 1) !important;
}
.icon-tail{
  transform: scaleX(-1);
}
.space-button{
  margin-left: 115px;
}
</style>
